import React from 'react';
import { useSelector } from 'react-redux';
import { getQuote } from './QuoteSlice';

function KciMessage() {
  const { message } = useSelector(getQuote);
  return (
    <div>
      {message
                && (
                <div
                  className="alert alert-danger alert-dismissible"
                  dangerouslySetInnerHTML={{ __html: message }}
                />
                )}
    </div>
  );
}

export default KciMessage;
